import type { ReactNode } from 'react'

import { Icon, Table, Text } from '@factorialco/deprecated-design-system'
import type { JustifyContent } from '@factorialco/deprecated-design-system'

import Tooltip from 'modules/core/components/Tooltip'
import i18n from 'modules/core/lib/i18n'

interface HeaderName {
  name: ReactNode
  colSpan: number
  attribute: string
  justifyContent: JustifyContent
}

interface HeaderProps {
  isDraftStatus: boolean
  isProductQuote: boolean
}
const Header = ({ isDraftStatus, isProductQuote }: HeaderProps) => {
  const generateHeaderNames = () => {
    const headerNames: HeaderName[] = [
      {
        name: '',
        colSpan: 2,
        attribute: 'description',
        justifyContent: 'flexStart',
      },
      {
        name: isProductQuote
          ? i18n.t('finance.quotes.quote_phases_table.headers.units')
          : i18n.t('finance.quotes.quote_phases_table.headers.hours_units'),
        colSpan: 2,
        attribute: 'hours',
        justifyContent: 'flexEnd',
      },
    ]
    if (!isProductQuote) {
      headerNames.push({
        name: (
          <>
            <Tooltip.Alt
              attachment="bottom center"
              label={i18n.t('finance.quotes.quote_phases_table.headers_tooltips.cost_per_hour')}
            >
              <Icon.Medium color="grey800" icon="info-circle-line" />
            </Tooltip.Alt>
            <Text size="200" weight="semibold">
              {i18n.t('finance.quotes.quote_phases_table.headers.cost_per_hour')}
            </Text>
          </>
        ),
        colSpan: 2,
        attribute: 'cost',
        justifyContent: 'flexEnd',
      })
    }
    headerNames.push({
      name: isProductQuote ? (
        i18n.t('finance.quotes.quote_phases_table.headers.unit_price')
      ) : (
        <>
          <Tooltip.Alt
            attachment="bottom center"
            label={i18n.t('finance.quotes.quote_phases_table.headers_tooltips.bill_rate')}
          >
            <Icon.Medium color="grey800" icon="info-circle-line" />
          </Tooltip.Alt>
          <Text size="200" weight="semibold">
            {i18n.t('finance.quotes.quote_phases_table.headers.bill_rate')}
          </Text>
        </>
      ),
      colSpan: 2,
      attribute: 'bill',
      justifyContent: 'flexEnd',
    })

    if (isProductQuote) {
      headerNames.push({
        name: i18n.t('finance.quotes.quote_phases_table.headers.tax'),
        colSpan: 2,
        attribute: 'taxt_rate',
        justifyContent: 'flexEnd',
      })
    } else {
      headerNames.push({
        name: i18n.t('finance.quotes.quote_phases_table.headers.profit'),
        colSpan: 2,
        attribute: 'profit',
        justifyContent: 'flexEnd',
      })
      headerNames.push({
        name: i18n.t('finance.quotes.quote_phases_table.headers.total_cost'),
        colSpan: 2,
        attribute: 'total_cost',
        justifyContent: 'flexEnd',
      })
    }

    headerNames.push({
      name: i18n.t('finance.quotes.quote_phases_table.headers.total_to_bill'),
      colSpan: 2,
      attribute: 'total_bill',
      justifyContent: 'flexEnd',
    })

    if (isDraftStatus) {
      headerNames.push({ name: '', colSpan: 1, attribute: 'actions', justifyContent: 'center' })
    }

    return headerNames
  }

  return (
    <Table.Head>
      <Table.Row>
        {generateHeaderNames().map((headerName) => (
          <Table.HeadCell
            justifyContent={headerName.justifyContent}
            key={headerName.attribute}
            colSpan={headerName.colSpan}
          >
            {headerName.name}
          </Table.HeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
